/* global Search */

if (document.querySelector(".fbjs-search--life-at-wood")) {
    window.searchNewsLanding = new Search.default({
        url: "https://wood-search01.squiz.co.uk/s/search.json",
        collections: ["push-wood-careers"],
        additionalFBparams: {
            profile: "_default",
            "f.pageType|pageType": "Careers - Life@wood blog",
        },
        shouldFacetsFromUrlOverwriteActiveFacets: true,
        onFiltersUpdate: () => {},
        beforeSearch: () => {},
        results: {
            numRanks: 6,
        },
        sort: {
            type: "date",
        },
        activeFacets: {
            target: ".active-facets",
        },
        activeFacetsOnStart: {
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },

        pagination: {
            loadMore: true,
        },

        templates: {
            activeFacet: (name, param) => {
                const changeName = name
                    .replace(/_ampersand_/gi, "&")
                    .replace(/_comma_/gi, ",");
                return `
                  <span param="${param}" name="${name}">
                    ${changeName}
                  </span>
                `;
            },
            articleTemplate: (fields) => {

                return `<div class=" cards__card-wrapper static-size-4">
                <a href="https://wood-search01.squiz.co.uk${
                                    fields.clickTrackingUrl
                                }">
                    <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                        <!-- card image -->
                        <div class="cards__image-wrapper">
                            <div class="cards__image" style="
                                    background-image: url('${
                                        fields.metaData.image
                                    }');
                                "></div>
                        </div>
                        <div class="cards__content no-gutters flex-column justify-content-between">
                            <div>
                                <!-- card type - same as section header -->
                                <div class="informations__wrapper">
                                    <div class="type truncate-lines-2"> ${
                                        fields.metaData.t
                                    }</div>
                                </div>
                                <!-- card title -->
                                <p class="title truncate-lines-2">
                                ${fields.metaData.description || ""}
                                </p>
                            </div>
                            <!-- link -->
                            <div class="cards__link">
                            <object><a href="https://wood-search01.squiz.co.uk${
                                    fields.clickTrackingUrl
                                }"> Read more </a></object>
                            </div>
                        </div>
                    </article>
                    </a>
                </div>`;
            },

            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: () => {
                return "";
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                <div class="search-field">
                <h5>What are you looking for today?</h5>
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Search..."
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },

            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startrank
             * @returns {string}
             **/
            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },

            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },

            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },

            /**
             * @name loadMoreTemplate
             * @param fields
             * @returns {string}
             **/
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--tertiary">Load more</button></div>';
            },

            facetCheckbox: ({ categories, singleChoice }, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },

            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                return "<div>We're sorry, we couldn't find anything matching .</div>";
            },
        },
    });

    window.searchNewsLanding.init();
}
